import React from 'react';
import './AboutPage.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGithub,
} from '@fortawesome/free-brands-svg-icons';
import usePageView from '../../hooks/analytics';

export default function AboutPage() {
  usePageView('/about');

  return (
    <div className="about-page">
      <section className="about-dark-header">
        <div className="about-header-full">
          <h3>Welcome to Scout</h3>
          <h2>Uncover the city&apos;s data.</h2>
        </div>
        <div className="content">
          <div>
            <p>We built Scout to make data more accessible.</p>
          </div>
          <div>
            <p>
              Scout is a new way to browse governmental open data portals. It
              focuses on data discoverability, joinability and creating curated
              collections of datasets that deal with a specific subject.
            </p>
            <p>
              By focusing not on agencies, or departments, Scout allows you to
              quickly identify datasets that are related to each other and can
              even potentially be joined together using a common ID. Having
              found these collections of datasets, Scout makes it easy to share
              your findings with others through our data collections.
            </p>
          </div>
        </div>
      </section>
      <section className="about-section-two-up">
        <div className="center">
          <img src={`${process.env.PUBLIC_URL}/circles.png`} alt="" />
        </div>
        <div>
          <h3>Lots of datasets are lonely</h3>
          <p>
            While many open data sets are downloaded and viewed daily, there are
            many more that get far less attention. We think there is a lot of
            untapped potential in these datasets, especially when combined with
            some of the better known ones.
          </p>
          <p>
            Our goal is to make sure that when you search for a dataset, you are
            exposed to every other dataset that might also be relevant.
          </p>
        </div>
      </section>

      <section className="about-section-two-up teal">
        <div className="social">
          <ul>
            <li>
              <a
                href="https://github.com/BetaNYC"
                rel="noopener noreferrer"
                target="_blank"
              >
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3>How can I contribute?</h3>
          <p>
            We want Scout to grow to help support the needs of the open data
            community. That means that we need a lot of voices helping us shape
            the features we are developing. If you would like to suggest a
            feature, please either open a ticket on github or reach out to us on
            one of our social media channels.
          </p>
          <p>
            If you are a developer, designer or want to contribute in a
            technical capacity we would love your help! Head over to our github
            page to open issues, suggest features, contribute pull requests and
            find beginner issues.
          </p>
        </div>
      </section>
    </div>
  );
}
